import { Injectable } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';
import { PersonnalisationGrillesLexiClient, NavigationItem as ClientNavigationItem } from '@lexi-clients/lexi';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { Configuration } from '@lexi-clients/lexi';

export interface NavigationItem {
  text: string;
  path: string | null;
  permissionsRequises?: string[];
  visible: boolean;
  items?: NavigationItem[];
}

@Injectable({
  providedIn: 'root',
})
export class DynamicNavigationMenuService {
  private refreshMenuSavSubject = new Subject<void>();
  refreshMenuSav$ = this.refreshMenuSavSubject.asObservable();

  constructor(  
    private personnalisationGrillesLexiClient: PersonnalisationGrillesLexiClient
  ) { }

  getNavigationMenuByDatagridStoragekey( storageKey : string ): Observable<NavigationItem[]> {
    return this.personnalisationGrillesLexiClient.getCustomGrillesToMenu(storageKey).pipe(
      map((items: ClientNavigationItem[]) =>
        items.map((item) => ({
          text: item.text || '',
          path: item.path,
          permissionsRequises: item.permissionsRequises || [],
          visible: item.visible,
          items: []
        }))
      )
    );
  }

  refreshMenu(){
    this.refreshMenuSavSubject.next();
  }
}